const commentItems = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustrated%20profile%20avatar%20in%20manga%20style%2C%20young%20male%20character%20with%20friendly%20expression%2C%20soft%20coral%20and%20amber%20color%20scheme%2C%20clean%20minimal%20design%2C%20circular%20composition&width=120&height=120&seq=avatar-comic-01&orientation=squarish',
    time: '2小时前',
    content: '羞羞歪歪漫画的阅读体验真的太棒了！下拉式竖屏阅读模式超级流畅，全部章节无删减完整呈现，追漫体验满分。推荐大家都来试试这个在线看入口！',
    likes: 128,
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustrated%20profile%20avatar%20in%20manga%20style%2C%20young%20female%20character%20with%20cute%20expression%2C%20soft%20pink%20and%20peach%20color%20scheme%2C%20clean%20minimal%20design%2C%20circular%20composition&width=120&height=120&seq=avatar-comic-02&orientation=squarish',
    time: '5小时前',
    content: '终于找到一个能看全部章节无删减的漫画平台了！羞羞歪歪漫画全集资源超丰富，每天都有更新，根本停不下来～',
    likes: 96,
  },
  {
    name: '熬夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustrated%20profile%20avatar%20in%20manga%20style%2C%20character%20with%20tired%20but%20happy%20expression%2C%20soft%20amber%20and%20coral%20color%20scheme%2C%20clean%20minimal%20design%2C%20circular%20composition&width=120&height=120&seq=avatar-comic-03&orientation=squarish',
    time: '1天前',
    content: '竖屏阅读模式是我用过最舒服的，下滑就能一直看不用翻页。羞羞歪歪漫画免费阅读入口太良心了，强烈安利！',
    likes: 87,
  },
  {
    name: '漫画老司机',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustrated%20profile%20avatar%20in%20manga%20style%2C%20mature%20male%20character%20with%20confident%20expression%2C%20soft%20golden%20and%20amber%20color%20scheme%2C%20clean%20minimal%20design%2C%20circular%20composition&width=120&height=120&seq=avatar-comic-04&orientation=squarish',
    time: '2天前',
    content: '看漫画十几年了，羞羞歪歪漫画是少数做到全部章节无删减的平台。下拉式阅读还原了纸质漫画的沉浸感，真的很用心。',
    likes: 65,
  },
  {
    name: '甜甜恋爱脑',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustrated%20profile%20avatar%20in%20manga%20style%2C%20young%20female%20character%20with%20dreamy%20expression%2C%20soft%20pink%20and%20coral%20color%20scheme%2C%20clean%20minimal%20design%2C%20circular%20composition&width=120&height=120&seq=avatar-comic-05&orientation=squarish',
    time: '3天前',
    content: '恋爱漫画全部章节都在这找到了！无删减内容看着太过瘾了，每天睡前都要刷几话羞羞歪歪漫画才能安心睡觉！',
    likes: 143,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          读者热评
        </h2>
        <div className="max-w-4xl mx-auto space-y-4">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <h4 className="text-sm font-medium text-foreground-900">{item.name}</h4>
                      <span className="text-xs text-foreground-500">{item.time}</span>
                    </div>
                    <div className="flex items-center gap-1 text-foreground-400">
                      <i className="ri-thumb-up-line text-sm cursor-pointer hover:text-primary-500 transition-colors"></i>
                      <span className="text-xs">{item.likes}</span>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}